import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import LoginPopup from './LoginPopup'

const AuthWrapper = ({ children }) => {
  const { authenticated, user, isLoading, login } = useAuth()

  const handleLogin = (userData) => {
    login(userData)
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-gray-600">Načítání...</div>
      </div>
    )
  }

  if (!authenticated) {
    return (
      <div className="relative min-h-screen bg-gray-100">
        <LoginPopup onLogin={handleLogin} />
      </div>
    )
  }

  return children
}

export default AuthWrapper
